export default {
  fetchUnits(state, data) {
    return (state.allUnits = data)
  },
}
